import Animation from "./class.Animation.js";

const defaultDuration = 1000;

/**
 * Fades an element in slowly.
 * @example controller.FadeIn.start({bubbleView});
 * @example controller.FadeIn.start({bubbleView, duration}).scroll();
 */
export default class FadeIn extends Animation {
	constructor(options) {
		super(options);
	}

	/**
	 *
	 * @param {*} options
	 * @param {*} options.bubbleView
	 * @param {number} options.duration
	 */
	_animate(options) {
		var {bubbleView, duration} = options;
		if (_.isUndefined(duration)) {
			duration = defaultDuration;
		}
		return Promise.all([
			new Promise((resolve) => {
				bubbleView.$el.hide().fadeIn({
					duration: duration * this.animationController.getDurationModifier(),
					complete: resolve,
				});
			}),
			new Promise((resolve) => {
				setTimeout(() => {
					resolve();
				}, defaultDuration * this.animationController.getMessageDelayModifier());
			}),
		]);
	}
}
